import React, { ImgHTMLAttributes } from 'react';

export const LogoIconNames = [
  '002',
  '008',
  '009',
  '011',
  '013',
  '014',
  '016',
  '022',
  '213',
  '451',
  '484',
  'account',
  'accurate-white',
  'accurate',
  'aruna',
  'bareksa',
  'cash-management',
  'cimb-niaga',
  'credimart',
  'dana',
  'doku',
  'expense-management',
  'jurnal',
  'jurnal2',
  'linkaja',
  'mastercard',
  'mcp',
  'nicepay',
  'danamon',
  'ojk-white',
  'ojk',
  'others',
  'ovo',
  'oy-bulk-disbursement',
  'oy-icon',
  'oy-payment-checkout-link',
  'oy-transaction-data',
  'oy-white',
  'oy',
  'qris-bagi',
  'qris-bnc',
  'qris-danamon',
  'qris-dsp',
  'qris-mnc',
  'qris-nobu',
  'qris-shopee',
  'qris-gv',
  'qris-bss',
  'qris',
  'receive-money',
  'send-money',
  'shopeepay',
  'verification',
  'vokraf',
  'xero-white',
  'xero',
] as const;

export type LogoIconName = (typeof LogoIconNames)[number];

const BASE_URL =
  'https://s3-ap-southeast-1.amazonaws.com/oy-static-assets/pay/uiicon/logo';

type LogoIconProps = {
  /**
   * To add new icon, you need to ask infra team to upload your new icon.
   * And don't forget to add the name to {@link LogoIconName}
   * @BASE_URL https://s3-ap-southeast-1.amazonaws.com/oy-static-assets/pay/uiicon/logo
   */
  name: LogoIconName;
} & ImgHTMLAttributes<HTMLImageElement>;

export function LogoIcon({ name, ...props }: LogoIconProps) {
  return <img {...props} alt="logo" src={`${BASE_URL}/${name}.svg`} />;
}
